import { render } from "./noticeVue.vue?vue&type=template&id=7bca50ba&lang=true"
import script from "./noticeVue.vue?vue&type=script&lang=js"
export * from "./noticeVue.vue?vue&type=script&lang=js"

import "./noticeVue.vue?vue&type=style&index=0&id=7bca50ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__